import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const responseSchema = yup
  .array()
  .of(
    yup.object({
      id: yup.number().required(),
      added_by: yup.string().required(),
      created: yup.string().required(),
      notes: yup.string().nullable(),
    }),
  )
  .required();

const composeResponse = (response) => {
  const data = response?.data?.data || [];
  return data;
};

export function useAppointmentCheckinQuery({ appointmentId }, options = {}) {
  return useQuery(
    [QUERY_KEYS.appointments.checkin, appointmentId],
    async () => {
      const res = await http.get(
        HTTP_ENDPOINTS.appointments.getCheckin(appointmentId),
      );
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    options,
  );
}
